import { Directive, HostListener } from "@angular/core";


@Directive({
  selector: '[appNoMouseScroll]'
})
export class NoMouseScrollDirective {

  constructor() { }


  @HostListener('wheel', ['$event'])
  onWheel(event: Event) {
    event.preventDefault();
  }

}
